import actions from './actions'

const initState = {
    notify: [],
    total: 0,
    pageIndex: 0,
}

const NotifyReducer = (state = initState, action) => {
    switch (action.type) {
        case actions.type.GET_LIST_NOTIFY_DONE:
            return {
                ...state,
                ...{
                    notify: action.payload.isRefresh
                        ? action.payload.data
                        : state.notify.concat(action.payload.data),
                },
            }
        case actions.type.UPDATE_TOTAL_INDEX:
            return {
                ...state,
                ...{
                    total: action.payload.total,
                    pageIndex: action.payload.index,
                },
            }

        default:
            return state
    }
}

export default NotifyReducer
